import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import SegmentedPicker from '../common/controls/segmentedPicker';
const CabinetViewPicker = _ref => {
  let cabinetIdentifier = _ref.cabinetIdentifier,
    selectedView = _ref.selectedView,
    setSelectedView = _ref.setSelectedView,
    views = _ref.views;
  const handleSelectedViewChange = newView => {
    if (newView && newView !== selectedView) {
      setSelectedView(cabinetIdentifier, newView);
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ifp-title"
  }, "View")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(SegmentedPicker, {
    hideLabel: true,
    value: selectedView,
    names: views.map(view => view),
    values: views,
    onChange: handleSelectedViewChange,
    className: "no-margin-bottom"
  })))));
};
CabinetViewPicker.propTypes = {
  cabinetIdentifier: PropTypes.string.isRequired,
  selectedView: PropTypes.string.isRequired,
  setSelectedView: PropTypes.func.isRequired,
  views: PropTypes.arrayOf(PropTypes.string).isRequired
};
export default CabinetViewPicker;